import {
  AEMStipulation,
  getEmptyContent,
  isDisplay,
  isValidData,
  Stipulation
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';

export const getStipulation = (
  aem: AEMStipulation | undefined,
  featureFlag: boolean | undefined
): Stipulation => {
  try {
    return isValidData<
      AEMStipulation,
      [AEMStipulation | undefined, boolean | undefined]
    >('title', aem, featureFlag)
      ? adaptStipulation(aem as AEMStipulation, featureFlag as boolean)
      : isDisplay<Stipulation>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'LANDING_PAGE', 'STIPULATION');
    return getEmptyContent<Stipulation>('', [], true);
  }
};

export const adaptStipulation = (
  aem: AEMStipulation,
  featureFlag: boolean
): Stipulation => {
  return {
    title: aem.title,
    content: aem.description,
    disabled: !featureFlag,
    loaded: true
  };
};
